import React  from 'react';
import Helmet from 'react-helmet';
import { useSelector } from 'react-redux';
import Calendar from 'components/pages/calendar';

const LcSchedule = () => {
  const user = useSelector((state) => state.user.user);

  return (
    <div>
      <Helmet title="Calendar" />
      <Calendar user={user} />
    </div>
  );
};

export default LcSchedule;
